import React from 'react';
import { CheckIcon } from 'lucide-react';
interface ChoiceChipProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  children: React.ReactNode;
  className?: string;
}

/**
 * Multi-select chip. Selection is carried by a check mark and a border weight
 * change as well as colour, and the target is never below 44px.
 */
export function ChoiceChip({
  checked,
  onChange,
  children,
  className = ''
}: ChoiceChipProps) {
  return <button type="button" role="checkbox" aria-checked={checked} onClick={() => onChange(!checked)} className={`inline-flex min-h-tap items-center gap-2 rounded-pill border px-4 text-small transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-card ${checked ? 'border-primary bg-primary-soft font-medium text-primary-text' : 'border-rule bg-card text-ink hover:bg-canvas'} ${className}`} data-id="element-521" data-mp="cw4egldm96uh">
      {checked ? <CheckIcon aria-hidden="true" className="h-4 w-4 shrink-0" data-id="element-522" data-mp="eei42sdb6m1j" /> : null}
      {children}
    </button>;
}
interface ConsentCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  children: React.ReactNode;
  id?: string;
}
export function ConsentCheckbox({
  checked,
  onChange,
  children,
  id
}: ConsentCheckboxProps) {
  return <label htmlFor={id} className="flex min-h-tap cursor-pointer items-start gap-3 py-2 text-body text-ink" data-id="element-523" data-mp="sbersky4rne7">
      <input id={id} type="checkbox" checked={checked} onChange={event => onChange(event.target.checked)} className="mt-0.5 h-5 w-5 shrink-0 rounded-control border-rule accent-[color:var(--color-primary)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2" data-id="element-524" data-mp="12bffsk6y2roq" />
      <span data-id="element-525" data-mp="1g4ww7w4c3oaj">{children}</span>
    </label>;
}